import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'recipientListSearch' })
export class RecipientListSearchPipe implements PipeTransform {
  public transform(employeeList: any[], searchText: any): any {
    if (searchText == '' || employeeList == null) {
      return employeeList;
    }

    let employees: any[] = []

    employeeList.forEach(
        item => {
            // If the employee name matches the search add the entire employee fields list to be returned
          if(item.user === null) {
            if(item.recipientType.toUpperCase().includes(searchText.toUpperCase())){
              employees.push(item)
            }
          }
          else {
            if(item.user.firstName.toUpperCase().includes(searchText.toUpperCase()) || item.user.lastName.toUpperCase().includes(searchText.toUpperCase())){
              employees.push(item);
            }
          }

        }
    )

    return employees;
  }
}